var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{style:(_vm.getHeaderStyle)},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v(_vm._s(_vm.sub_title))])]),_c('div',{staticClass:"header_space"})])}
var staticRenderFns = []

export { render, staticRenderFns }